<script>
import { Bar } from 'vue-chartjs/legacy';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Finance } from 'financejs';
import VueSlideBar from 'vue-slide-bar';
import { formatCurrency } from '@/formatter/NumberFormatter';
import settingsService from '@/services/Settings/settingsService';

import {
  BarElement,
  CategoryScale,
  Chart,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
Chart.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ChartDataLabels,
);
const finance = new Finance();

var jurosComparativoAno = '';
var labelCDI = '';
var labelPoupanca = '';
var YEAR_IN_MONTHS = 12; // fix to use in the label of the chart

export default {
  name: 'simulador',
  components: { Bar, VueSlideBar },
  props: {
    minValue: { type: Number, default: 1000 },
    maxValue: { type: Number, default: 400000 },
    sliderMultipleValuesOf: { type: Number, default: 1000 },
    numOfPeriod: { type: Number, required: true, default: 12 },
    financingName: { type: String, required: true },
    rate: { type: Number, required: true },
    taxaJurosAno: { type: Number, required: true },
  },
  data() {
    return {
      settings: {},
      value: this.minValue,
      futureValue: undefined,
      comparativeWithCDIValue: undefined, //Comparativo com o CDI
      hasCDI: false, // inicializar o hasCDI como false
      localMinValue: this.minValue,
      localMaxValue: this.maxValue,
      localSliderMultipleValuesOf: this.sliderMultipleValuesOf,
      sliderOptions: {
        data: [],
      },
      chartData: {
        labels: [],
        datasets: [
          {
            data: [],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        plugins: {
          legend: {
            display: true,
            labels: {
              generateLabels() {
                let barLabels = [jurosComparativoAno, ...(labelCDI != '' ? [labelCDI] : []), labelPoupanca];
                let barBackgroundColors = ['#2F46E0', '#6937F3', '#120F0B'];

                return barLabels.map((label, index) => ({
                  text: label,
                  fillStyle: barBackgroundColors[index],
                }));
              },
            },
          },
          datalabels: {
            align: 'center',
            anchor: 'center',
            color: 'white',
            formatter: value => formatCurrency(value),
          },
        },
        tooltips: { enabled: false },
      },
    };
  },
  async mounted() {
    this.settings = await settingsService.getPrivateSettings();
    jurosComparativoAno = this.settings.platformName + " (" + this.taxaJurosAno + ')'; //.toFixed(2) + "% a.a)";

    this.localminValue = this.settings.VLR_MIN_SIMULATE > 0 ? this.settings.VLR_MIN_SIMULATE : this.minValue;
    this.localmaxValue = this.settings.VLR_MAX_SIMULATE > 0 ? this.settings.VLR_MAX_SIMULATE : this.maxValue;
    this.localsliderMultipleValuesOf = this.localminValue;

    // Verificar se CDI_RATE é maior que zero
    this.hasCDI = (this.settings.CDI_RATE > 0);

    if (this.hasCDI){
      labelCDI = 'CDI (' + (this.settings.CDI_RATE * YEAR_IN_MONTHS).toFixed(2) + '% a.a)';
    }
    
    labelPoupanca ='Poupança (' + (this.settings.POUPANCA_RATE * YEAR_IN_MONTHS).toFixed(2) + '% a.a)';
    this.sliderOptions.data = this.createSliderDataValues();
    //start with min value
    this.value = this.localMinValue;
    this.onValueChanged(this.localMinValue);
  },
  methods: {
    formatCurrency: formatCurrency,
    createSliderDataValues() {
      var sliderValue = undefined;
      const sliderLength =
        (this.localmaxValue - this.localminValue) / this.localsliderMultipleValuesOf + 1;
      return Array.from({ length: sliderLength }, () => {
        sliderValue =
          sliderValue === undefined
            ? this.localminValue
            : sliderValue + this.localsliderMultipleValuesOf;
        return formatCurrency(sliderValue);
        // return sliderValue;
      });
    },
    roiValue({ rate }) {
      var newValue = this.value;
      if (typeof this.value === 'string') {
        newValue = newValue.replace("R$ ", "");
        newValue = newValue.replace(".", "");
        newValue = newValue.replace(",00", "");
        newValue = Number(newValue);
      }

      const value = finance.FV(rate, newValue, this.numOfPeriod) - newValue;
      return Number(
        parseFloat(Math.round(value.toString() * 100) / 100).toFixed(2),
      );
    },
    onValueChanged(value) {
      if (typeof value === 'string') {
        value = value.replace('R$ ', '');
        value = value.replace('.', '');
        value = value.replace(',00', '');
        value = Number(value);
      }

      const roi = this.roiValue({ rate: this.rate });
      const total = value + roi;
      const cdiValue = this.roiValue({ rate: this.settings.CDI_RATE });
      const savingsValue = this.roiValue({ rate: this.settings.POUPANCA_RATE });
      this.futureValue = formatCurrency(total);
      this.comparativeWithCDIValue = ((roi * 100) / cdiValue).toFixed(2);
      const labelFinancing = this.financingName;
      this.chartData = {
        labels: [labelFinancing, ...(this.hasCDI ? ['CDI'] : []), 'Poupança'],
        datasets: [
          {
            data: [
              roi,
              ...(this.hasCDI ? [this.roiValue({ rate: this.settings.CDI_RATE })] : []),
              this.roiValue({ rate: this.settings.POUPANCA_RATE }),
            ],
            backgroundColor: ['#2F46E0', '#6937F3', '#120F0B'],
          },
        ],
      };
    },
  },
};
</script>

<style>
.simuladorField {
  margin-bottom: 40px;
}
</style>

<template>
  <div class="card" style="margin-left: 10px; margin-right: 10px;">
    <div class="card-body">
      <div style="margin-bottom: 40px; text-align: center;">
        <h2>
          Simule seu investimento
        </h2>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="simuladorField">
            <h4>
              Retorno ao final do investimento
            </h4>
            <div style="display: inline-flex;">
              {{ futureValue }}
              <div
                v-if="hasCDI && comparativeWithCDIValue > 100"
                style="display: flex; align-items: center; margin-left: 10px;"
              >
                <img
                  src="@/assets/images/arrow_up_icon.svg"
                  alt="arrow"
                  style="width: 12px;"
                />
                <span
                  style="font-size: 12px; color: #6A6A6A; margin-left: 2px;"
                >
                  {{
                    (hasCDI && comparativeWithCDIValue > 100) 
                      ? comparativeWithCDIValue + '% mais rentável que o CDI'
                      : ''
                  }}
                </span>
              </div>
            </div>
          </div>

          <div class="simuladorField">
            <h4>
              Quanto deseja investir
            </h4>
            <div style="font-size: 12px">
              Valores múltiplos de
              {{ formatCurrency(localsliderMultipleValuesOf, { prefix: false }) }}
              entre {{ formatCurrency(localminValue) }} a
              {{ formatCurrency(localmaxValue) }}
            </div>
            <VueSlideBar
              v-model="value"
              :data="sliderOptions.data"
              v-on:input="onValueChanged"
            />
          </div>

          <div class="simuladorField">
            <h4>
              Vencimento do título
            </h4>
            <div style="font-weight: 400;">{{ numOfPeriod }} meses</div>
            <div
              style="margin-top: 8px; color: #6A6A6A;  font-weight: 400; font-size: 14px;"
            >
              *Os valores de remuneração são brutos, sujeitos à tributação do
              I.R.
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <h4 css="text-center">Remuneração</h4>
          <Bar
            :chart-options="chartOptions"
            :chart-data="chartData"
            chart-id="chartId"
            dataset-id-key="label"
            :width="300"
            :height="300"
          />
        </div>
      </div>
    </div>
  </div>
</template>
